// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

function getCurrentValues(order, lastCorrectionValues) {
  var match = Belt_Option.mapWithDefault(lastCorrectionValues, Belt_Option.mapWithDefault(order.usedCar, [
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
          ], (function (x) {
              return [
                      x.orderRealTradeAmount,
                      x.orderEstimatedTradeAmount,
                      x.orderScrapyardIndicator,
                      x.orderUcBrand,
                      x.orderUcModel,
                      x.orderUcVersion,
                      x.orderUcRegistrationId,
                      x.orderUcVin,
                      x.orderUCFirstReleaseDate,
                      x.orderUCLastRegistrationDate,
                      x.ucPoliceNumber
                    ];
            })), (function (lastCorr) {
          return [
                  lastCorr.realTradeAmount,
                  lastCorr.estimatedTradeAmount,
                  lastCorr.scrapyardIndicator,
                  lastCorr.brandUsedCar,
                  lastCorr.modelUsedCar,
                  lastCorr.versionUsedCar,
                  lastCorr.usedCarRegistrationID,
                  lastCorr.vinUsedCar,
                  lastCorr.usedCarFirstReleaseDate,
                  lastCorr.usedCarLastRegistrationDate,
                  lastCorr.usedCarPoliceNumber
                ];
        }));
  return {
          orderUcBrand: match[3],
          orderUcModel: match[4],
          orderUcVersion: match[5],
          orderUcRegistrationId: match[6],
          orderUcVin: match[7],
          ucPoliceNumber: match[10],
          orderUCFirstReleaseDate: match[8],
          orderUCLastRegistrationDate: match[9],
          orderRealTradeAmount: match[0],
          orderEstimatedTradeAmount: match[1],
          orderScrapyardIndicator: match[2]
        };
}

function textToOption(text) {
  return Belt_Option.mapWithDefault(text, undefined, (function (x) {
                if (x.length === 0) {
                  return ;
                } else {
                  return x;
                }
              }));
}

function isVOEmpty(order, lastCorrectionValues) {
  var currVals = getCurrentValues(order, lastCorrectionValues);
  if (Belt_Option.isNone(textToOption(currVals.orderUcBrand)) && Belt_Option.isNone(currVals.orderScrapyardIndicator) && Belt_Option.isNone(currVals.orderUCFirstReleaseDate) && Belt_Option.isNone(textToOption(currVals.orderUcModel)) && Belt_Option.isNone(textToOption(currVals.ucPoliceNumber)) && Belt_Option.isNone(currVals.orderUCLastRegistrationDate) && Belt_Option.isNone(textToOption(currVals.orderUcRegistrationId)) && Belt_Option.isNone(textToOption(currVals.orderUcVersion)) && Belt_Option.isNone(textToOption(currVals.orderUcVin)) && Belt_Option.mapWithDefault(currVals.orderRealTradeAmount, true, (function (x) {
            return x === 0;
          }))) {
    return Belt_Option.mapWithDefault(currVals.orderEstimatedTradeAmount, true, (function (x) {
                  return x === 0;
                }));
  } else {
    return false;
  }
}

export {
  getCurrentValues ,
  textToOption ,
  isVOEmpty ,
}
/* No side effect */
